
import { useEffect } from "react";

/**
 * Hook for handling auth state changes affecting reagent loading
 */
export const useReagentAuthEffect = (
  authLoading: boolean, 
  user: any,
  refetchReagents: () => Promise<any>
) => {
  // Refresh reagents when auth state changes
  useEffect(() => {
    if (!authLoading && user) {
      console.log("Auth state loaded, user is authenticated. Refreshing reagents data.");
      const timer = setTimeout(() => {
        console.log("Executing auth state change refetch");
        refetchReagents();
      }, 500);
      
      return () => clearTimeout(timer);
    }
  }, [authLoading, user, refetchReagents]);
};
